// body fade in on load //
$(document.body).fadeIn(1000);

function formatCurrency(price) {
	const currency_separator = theme.currency_separator;
	const currency_format = theme.currency_format;
	const thousand_separator = theme.thousand_separator;
	price = price.toFixed(2).replace('.', currency_separator);
	price =
		price.length > 6
			? price.slice(0, -6) +
			  thousand_separator +
			  price.slice(-6)
			: price;
	price = currency_format.replace('{{amount}}', price);
	return price;
}

$(document).on('click', '#cart-added', function (event) {
	if (!$(event.target).closest('.modal-body').length) {
		$('.modal').hide();
		$('body').css('overflow', 'auto');
	}
});

$(document).on(
	'cart.requestComplete',
	function (event, cart) {
		jQuery.getJSON('/cart.js', function (cart) {
			var itemcount = cart.item_count;
			$('.cartcount').text(itemcount);
			$('.item_count').text(itemcount);
			$('.cartitemcount').text(itemcount);
			$('.basket-heading').show();
			$('.emptycart').hide();
			$('.cartpop-footer').show();
			getcartpop();
		});
	}
);

$('.newsletterbtn').click(function () {
	var email = $('.newsletter-join').val();
	window.location.href =
		'/pages/newsletter/?email=' + email;
});

$('.newsletter-join').keyup(function (e) {
	if (e.keyCode == 13) {
		var email = $('.newsletter-join').val();
		window.location.href =
			'/pages/newsletter/?email=' + email;
	}
});

$('.mobileheader .menu-toggle').click(function () {
	if ($('.mobile-menu').hasClass('active')) {
		$('.mobilesearch').slideUp();
		$('.mobile-menu').removeClass('active');
		$('.mobile-menu').slideUp('fast');
		$('#MainContent').fadeIn('medium');
		$('.mobile-sub-nested')
			.removeClass('active')
			.css('display', 'none');
		$('.mobile-sub-menu-expand').text('+');
	} else {
		$('.mobile-menu').addClass('active');
		$('.mobile-menu').slideDown('fast');
		$('#MainContent').fadeOut('medium');
	}
});

$(document).on(
	'click',
	'.mobile-menu.active .inner-main-row .colse-col',
	function () {
		$('.mobileheader .menu-toggle').click();
	}
);

$('.mobile-item-child').click(function () {
	var menu = $(this).find('.mobile-sub-nested');
	toggleicon = $(this).find('.mobile-sub-menu-expand');
	if (menu.hasClass('active')) {
		menu.removeClass('active');
		menu.fadeOut('medium');
		toggleicon.html('+');
		$(this).removeClass('active');
	} else {
		$(this).addClass('active');
		menu.addClass('active');
		menu.fadeIn('medium');
		toggleicon.html('-');
	}
});

function getcartpop() {
	var x = 0;
	jQuery.getJSON('/cart.js', function (response) {
		if (response.item_count == 0) {
			$('.basket-heading').hide();
			$('.emptycart').show();
			$('.cartpop-footer').hide();
			$('.cartcounts').hide();
		} else {
			$('.cartpop-footer').show();
		}
		var totalprice = response.total_price / 100;
		var total_with_vat = 0;

		response.items.forEach(element => {
			total_with_vat +=
				Math.round(element.price * theme.vat_rate) *
				element.quantity;
		});

		totalprice = totalprice * theme.vat_rate;
		var totalprice_withvat = total_with_vat / 100;

		$('.cartpop-total').text(
			formatCurrency(totalprice_withvat)
		);
		$('.cart-list').html('');
		var count = 0;
		$.each(response.items, function (index, product) {
			console.log('PRODUCT: ', product);
			try {
				var rrp_price = product.properties['_rrp_price'];
				var item_type = product.properties['_type'];
			} catch (err) {}
			if (x < 4) {
				var product_quantity = product.quantity;
				var count = x + 1;
				$('.cart-list').append(
					'<li class="cartpopitem" prod-url="' +
						product.url +
						'">\
					 <div class="cartpop-image"><img src="' +
						product.image +
						'"/></div>\
					 <div class="cart-pop-item">\
						 <div class="product-info-basket">\
						 <h5 class="main-title">' +
						product.title +
						'</h5>\
						<p class="sub-info">' +
						theme.strings.qty +
						': ' +
						product_quantity +
						'</p>\
						 </div>\
						 <div class="total-info">\
						 <p class="sub-info popup-price" translate="no" style="display: flex; flex-direction: column">' +
						(rrp_price ? `<span class="rrp-price">${formatCurrency((rrp_price * theme.vat_rate) / 100)}</span>` : '') +
						'<span>' +
						formatCurrency((product.price * theme.vat_rate) / 100) +
						'</span>' +
						'</p>\
						 <a href="/cart/change?line=' +
						count +
						'&amp;quantity=0">\
							 <small>' +
						theme.strings.remove +
						'</small>\
						 </a>\
						 </div>\
					 </div>\
					 </li>'
				);
				x++;
			}
		});

		$('.cartpopcount').text(x);
	});
}

getcartpop();

$(document).on('click', '.cartpopitem', function () {
	var produrl = $(this).attr('prod-url');
	window.location.href = produrl;
});

$('.modal-close').click(function () {
	$('.modal').hide();
	$('body').css('overflow', 'auto');
});

function menufix() {
	var scroll = $(window).scrollTop();
	if (
		scroll > 10 ||
		$('.mainheader').hasClass('search-active')
	) {
		$('.mainheader,.mobile-menu.desktop-hide').addClass(
			'menufix'
		);
		$('body').addClass('menufix-active');
	} else {
		$('.mainheader,.mobile-menu.desktop-hide').removeClass(
			'menufix'
		);
		$('body').removeClass('menufix-active');
	}
}
menufix();
$(window).scroll(function () {
	menufix();
});

/*************** Search Function **************/

$('.searchbox').on('focusin', function () {
	$(this).addClass('active');
});

$('.searchbox').on('focusout', function () {
	$(this).removeClass('active');
});

$('.searchbtn').click(function () {
	var elem = $(this);
	$('.mainmenu .sub-menu').css('display', 'none');
	if (!$(this).hasClass('active')) {
		$(this).addClass('active');
		$(this).find('.sub-menu').css('display', 'block');
		$('.searchbox').focus();
	}

	$(document).mouseup(function (e) {
		if (
			!$('.sub-menu').is(e.target) && // if the target of the click isn't the container...
			$('.sub-menu').has(e.target).length === 0 &&
			!$('.searchbtn').is(e.target) &&
			$('.searchbtn').has(e.target).length === 0
		) {
			// ... nor a descendant of the container
			$('.nav-item.searchbtn.new-search').removeClass(
				'showing'
			);
			$('.mainheader').removeClass('search-active');
			$('body').removeClass('search-active');
			$('.transparent-header').removeClass(
				'submenu-active'
			);

			var scroll = $(window).scrollTop();
			if (scroll <= 10) {
				$('.mainheader').removeClass('menufix');
				$('body').removeClass('menufix-active');
			}
			if ($('.mainlink').is(e.target)) {
				var mainitem = $(e.target).parent('.main-item');
				$('.mainlink').removeClass('white');
				if ($('.mainmenu .sub-menu').is(':visible')) {
					$('.mainmenu .sub-menu').css('display', 'none');
					mainitem.find('.sub-menu').show();
				} else {
					mainitem
						.find('.sub-menu')
						.css('display', 'block');
				}
				mainitem.find('.sub-menu').css('opacity', '1');
				mainitem
					.closest('.transparent-header')
					.addClass('active submenu-active');
			}
		}
	});
});

$(document).on('click', 'li.searchbtnnew', function () {
	$('.nav-item.searchbtn.new-search').addClass('showing');
	jQuery('.searchbtn.new-search input.searchbox').focus();
	jQuery('.searchbtn.new-search input.searchbox').click();
	$('.mainheader').addClass('menufix search-active');
	$('body').addClass('search-active');
	$('.transparent-header').addClass('submenu-active');
	$('body').addClass('menufix-active');
});

$(document).on(
	'click',
	'.searchbtn.new-search span.colse-icon-s',
	function () {
		$('.nav-item.searchbtn.new-search').removeClass(
			'showing'
		);
		$('.mainheader').removeClass('search-active');
		$('body').removeClass('search-active');
		$('.transparent-header').removeClass('submenu-active');

		var scroll = $(window).scrollTop();
		if (scroll <= 10) {
			$('.mainheader').removeClass('menufix');
			$('body').removeClass('menufix-active');
		}
	}
);

$('.view-all-search').click(function () {
	searchViewAll();
});

$('.searchbox').keyup(function (e) {
	if (
		e.which == 13 &&
		$('.nav-item.searchbtn.new-search').hasClass('showing')
	) {
		searchViewAll();
	}
});

function searchViewAll() {
	var query = $('.searchbox').val();
	query = query.replaceAll('&', '%26');
	query = query.replaceAll(' ', '+');
	window.location.href = '/search?q=' + query;
}

function searchProducts(search, elem) {
	if (search != '') {
		elem.find('.termsearched').text("'" + search + "'");
	} else {
		elem.find('.termsearched').text('');
	}
	$.ajax({
		url: '/search',
		method: 'GET',
		data: {
			view: 'quick',
			q: search,
			type: 'product',
		},
		success: function (result) {
			var data = jQuery.parseJSON(result);
			elem.find('#prodsearch-list').html('');
			$('.view-all-search').show();
			var count = 0;
			$.each(data, function (index, product) {
				var prodtitle = product.value,
					prodsku = product.sku,
					prodtags = product.tags;
				if (
					typeof prodtags == 'string' &&
					prodtags.includes('hidefromsearch')
				) {
					return;
				}
				if (prodtitle.indexOf('*') == -1) {
					elem.find('#prodsearch-list').append(
						"<li class='search-proditem' prod-link='" +
							product.url +
							"'>\
              <div class='search-prodimg'>\
                <img src='" +
							product.thumb +
							"'/>\
              </div>\
              <div class='search-prodinfo'>\
                <div class='pro-info'>\
                  <p>" +
							prodtitle +
							'</p>\
                  <p>' +
							prodsku +
							"</p>\
                </div>\
                <div class='prodprice'>" +
							product.price +
							'</div>\
              </div>\
            </li>'
					);

					count++;
				}
				if (count == 8) {
					return false;
				}
			});
		},
	});
}

$(document).on('click', '#pagesearch-list li', function () {
	var link = $(this).attr('page-url');
	window.location.href = link;
});

$('.searchlabel').on('input', '.searchbox', function () {
	var search = $(this).val(),
		elem = $(this).closest('.searchbtn').find('.sub-menu');

	searchProducts(search, elem);
});

$(document).on('click', '.search-proditem', function () {
	var producturl = $(this).attr('prod-link');
	window.location.href = producturl;
});

$('.link-item').click(function () {
	var menu = $(this)
		.closest('.mobile-item')
		.find('.mobile-nested');
	toggleicon = $(this).find('.mobile-menu-expand');
	if (menu.hasClass('active')) {
		menu.removeClass('active');
		menu.fadeOut('medium');
		toggleicon.html('+');
		$(this).removeClass('active');
	} else {
		$(this).addClass('active');
		menu.addClass('active');
		menu.fadeIn('medium');
		toggleicon.html('-');
	}
});

$('.active-search').on(
	'keyup',
	'.mobilesearchbox',
	function () {
		var search = $(this).val(),
			elem = $(this)
				.closest('.active-search')
				.find('.mobilesearchresults');

		elem.slideDown();
		searchProducts(search, elem);
	}
);

$(document).on(
	'click',
	'.mobilesearchresults a.colse-icon-m',
	function () {
		$('.mobilesearchresults').hide();
	}
);

$('.quickbuy').click(function () {
	if ($(this).attr('disabled')) {
		console.log('disabled');
	} else {
		var variantid = $(this).attr('variant-id'),
			prodhandle = $(this).attr('data-handle');
		let price = $(this).attr('data-price');
		let rrp_price = $(this).attr('data-rrp-price');

		$('#cart-added .modal-load').html('');

		if ($('body').hasClass('template-cart')) {
			window.location.href = `/cart/add?id=${variantid}&quantity=1`;
		} else {
			$.ajax({
				url: '/products/' + prodhandle + '?view=cart',
				type: 'get',
				success: function (response) {
					$('#cart-added .modal-load').html(response);
					$('#cart-added').show();
					$('body').css('overflow', 'hidden');

					var cartItems = CartJS.cart.items;
					var newQty = 0;

					for (item in cartItems) {
						if (cartItems[item].variant_id == variantid) {
							newQty = cartItems[item].quantity;
						}
					}

					CartJS.addItem(variantid, 1, {
						_rrp_price: rrp_price,
					});
					newQty = newQty + 1;
					price = formatCurrency(
						(price * newQty * theme.vat_rate) / 100
					);
					rrp_price = formatCurrency(
						(rrp_price * newQty * theme.vat_rate) / 100
					);

					$(
						'#cart-added .added-product #product-quantity-top'
					).val(newQty);
					$('#cart-added .added-product .price').html(`
						<span class="rrp-price">${rrp_price}</span>
						<span class="current-price">${price}</span>`);
					$('.item-backbox #product-quantity-top').attr(
						'placeholder',
						newQty
					);

				document
					.querySelectorAll('.modaladdtocart')
					.forEach(item => {
						item.addEventListener('click', modalAddToCart);
					});
				document
					.querySelectorAll('.remove-btn span')
					.forEach(item => {
						item.addEventListener('click', modalClearItem);
					});
				},
			});
		}
	}
});

$('.engraving-add-to-basket').click(function () {
	if ($(this).attr('disabled')) {
		console.log('disabled');
	} else {
		var variantid = $(this).attr('variant-id');
		let price = $(this).attr('data-price');

		var cartItems = CartJS.cart.items;
		var newQty = 0;

		var rrp_price = $(this).attr('data-rrp-price');


		for (item in cartItems) {
			if (cartItems[item].variant_id == variantid) {
				newQty = cartItems[item].quantity;
			}
		}

		var engravingData = {};
		$('.engraving-span').each(function() {
			var name = $(this).attr('data-name');
			var value = $(this).text();
			engravingData[name] = value;
		});

		if (rrp_price) {
			engravingData['_rrp_price'] = rrp_price;
		}

		CartJS.addItem(variantid, 
			1,
			engravingData
		);


		$(this).prop('disabled', true);
		$(this).html(`<span>Added!</span>`);

	}
});

function modalAddToCart() {
	$(this).prop('disabled', true);
	const width = $(this).width();
	$(this).html(
		`<span style="width: ${width}px; display: inline-block;">Added!</span>`
	);

	var variantid = $(this).attr('variant-id'),
		quantity = $(this)
			.closest('.atb-row-one')
			.find('#product-quantity-top')
			.val(),
		placeholder = $(this)
			.closest('.atb-row-one')
			.find('#product-quantity-top')
			.attr('placeholder');

	quantity = parseInt(quantity);
	placeholder = parseInt(placeholder);

	if (!quantity) {
		if (!placeholder) {
			quantity = 1;
		} else {
			quantity = placeholder;
		}
	}

	if (Number.isInteger(quantity) && quantity > 0) {
		var cartItems = CartJS.cart.items;
		var newQty = 0;
		for (item in cartItems) {
			if (cartItems[item].variant_id == variantid) {
				newQty = cartItems[item].quantity;
			}
		}
		CartJS.addItem(variantid, quantity, {
			_rrp_price: $(this).attr('data-rrp-price'),
		});
		newQty = newQty + quantity;
		$(this)
			.closest('.modal-product')
			.find('.current-quantity')
			.text(newQty);
		$('.item-backbox #product-quantity-top').attr(
			'placeholder',
			newQty
		);
	}

	setTimeout(
		function () {
			$(this).prop('disabled', false);
			$(this).html('<span>Add to Basket</span>');
		}.bind(this),
		1000
	);
}

function modalClearItem(id) {
	var variantid = $(this).attr('variant-id');
	CartJS.updateItemById(variantid, 0);
	$(this)
		.closest('.modal-product')
		.find('.current-quantity')
		.text('0');
}

/**************** Product Page *****************/

$('.mainaddtocart').click(function () {
	var variantid = $(this).attr('variant-id'),
		prodhandle = $(this).attr('data-handle'),
		quantity = $(this)
			.closest('.atb-row-one')
			.find('#product-quantity-top')
			.val();

	var rrp_price = $(this).attr('data-rrp-price');

	quantity = parseInt(quantity);
	if (!quantity) {
		quantity = 1;
	}

	if (Number.isInteger(quantity) && quantity > 0) {
		$('#cart-added .modal-load').html('');
		$.ajax({
			url:
				'../products/' +
				prodhandle +
				'?variant=' +
				variantid +
				'&view=cart',
			type: 'get',
			success: function (response) {
				$('#cart-added .modal-load').html(response);
				$('#cart-added').show();
				$('body').css('overflow', 'hidden');
				var cartItems = CartJS.cart.items;
				var newQty = 0;
				for (item in cartItems) {
					if (cartItems[item].variant_id == variantid) {
						newQty = cartItems[item].quantity;
					}
				}
				CartJS.addItem(variantid, quantity, {
					_rrp_price: rrp_price,
				});
				newQty = newQty + quantity;
				$(
					'#cart-added .added-product #product-quantity-top'
				).val(newQty);
				$('.item-backbox #product-quantity-top').attr(
					'placeholder',
					newQty
				);
				document
					.querySelectorAll('.modaladdtocart')
					.forEach(item => {
						item.addEventListener('click', modalAddToCart);
					});
				document
					.querySelectorAll('.remove-btn span')
					.forEach(item => {
						item.addEventListener('click', modalClearItem);
					});
				document
					.querySelectorAll(
						'.modal-load .qty-select-arrow-container'
					)
					.forEach(item => {
						item.addEventListener('click', qtySelectClick);
					});
			},
		});
	}
});

$('document').ready(function () {
	$('.qty-select-arrow-container').click(function () {
		qtySelectClick.call(this);
	});
});

function qtySelectClick() {
	const parent = $(this).parent();
	const dropdown = parent.find('.qty-select-dropdown')[0];
	const input = parent.find('.qty-select-input');
	if ($(dropdown).is(':visible')) {
		$(dropdown).hide();
		return;
	}
	$(dropdown).show();

	document.addEventListener('click', function (event) {
		if ($.contains(dropdown, event.target)) {
			$(input).val(event.target.value).trigger('change');
			$(dropdown).hide();
			document.removeEventListener(
				'click',
				arguments.callee
			);
		} else if (!$.contains(parent[0], event.target)) {
			$(dropdown).hide();
			document.removeEventListener(
				'click',
				arguments.callee
			);
		}
	});
}

if (parent !== window) {
	$('body').addClass('iframe');
}
if (
	window.location.hostname === 'localhost' ||
	window.location.hostname === '127.0.0.1'
) {
	$('body').addClass('local');
}

/* Collection Carousel */
$(document).ready(function () {
	$('.collection-carousel.play').slick({
		dots: true,
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		arrows: false,
		autoplay: false,
		fade: true,
	});

	let collectionCarouselInterval = setInterval(function () {
		$('.collection-carousel.play').slick('slickNext');
	}, 2000);

	$('.collection-carousel.play>.slick-dots').on(
		'click',
		function () {
			clearInterval(collectionCarouselInterval);
		}
	);
});
